import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom'; // Import Link for navigation
import './Home.css';
import backgroundVideo from '../Assets/3126361-uhd_3840_2160_25fps.mp4';
import firmwareIcon from '../Assets/firmware.jpg';
import hardwareIcon from '../Assets/hardware.jpeg';
import softwareVideo from '../Assets/GIF2.mp4'; // Changed to video
import mechanicalIcon from '../Assets/mech.jpeg';
import testing from '../Assets/testing.jpeg';
import production from '../Assets/production.jpg';
import pcb from '../Assets/pcb.jpg';
import mobileapp from '../Assets/mobileapp.jpeg';
import telecom from '../Assets/telecom.jpg';
import energypower from '../Assets/energy power.jpg';
import mining from '../Assets/mining.jpg';
import health from '../Assets/health.jpg';
import indusauto from '../Assets/indusauto.jpg';
import aqua from '../Assets/aqua expert.jpg';
import water from '../Assets/water expertr.jpg';
import telematics from '../Assets/tele.jpg';
import transport from '../Assets/transportindustry.jpg';
import foodChain from '../Assets/foodindustry.jpg';
import smartCities from '../Assets/smart cities.jpeg';
import greenInfra from '../Assets/green infra.jpg';
import industry1 from '../Assets/firm.jpg';
import industry2 from '../Assets/pcb111.jpg';
import industry3 from '../Assets/mech.jpg';
import productEngIcon from '../Assets/pe.jpg';
import productSolutionIcon from '../Assets/p&s.jpeg';
import manufacturingIcon from '../Assets/manu.jpg';
import techConsultingIcon from '../Assets/tc.jpg';
import productImage1 from '../Assets/Picture1lora.jpg';
import productImage2 from '../Assets/fuel fleet.jpeg';
import productImage3 from '../Assets/gateways1.jpeg';
import productImage4 from '../Assets/picture rftag.jpg';
import productImage5 from '../Assets/rrrr.jpg';
import productImage6 from '../Assets/asset.jpeg';
import productImage7 from '../Assets/water quality.jpg';
import productImage8 from '../Assets/bas.jpeg';
import productImage9 from '../Assets/truck temp1.jpeg';
import productImage10 from '../Assets/cold s.jpeg';
import productImage11 from '../Assets/transport.jpg';
import productImage12 from '../Assets/data t.jpeg';
import productImage13 from '../Assets/power.jpeg';

// Custom hook to get window size
function useWindowSize() {
    const [windowSize, setWindowSize] = useState({
        width: undefined,
    });

    useEffect(() => {
        function handleResize() {
            setWindowSize({
                width: window.innerWidth,
            });
        }

        window.addEventListener('resize', handleResize);
        handleResize(); // Initial call
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    return windowSize;
}

const Home = () => {
    useEffect(() => {
        const strengthItems = document.querySelectorAll('.strength-item');
        const observer = new IntersectionObserver(
            (entries) => {
                entries.forEach((entry) => {
                    if (entry.isIntersecting) {
                        entry.target.classList.add('animate');
                        setTimeout(() => {
                            entry.target.classList.add('animation-complete');
                        }, 800);
                    }
                });
            },
            { threshold: 0.3 }
        );

        strengthItems.forEach((item) => observer.observe(item));

        return () => {
            strengthItems.forEach((item) => observer.unobserve(item));
        };
    }, []);

    // Carousel state and logic for Industries
    const [currentSlide, setCurrentSlide] = useState(0);
    const industries = [
        { img: telecom, name: 'Telecom', route: '/Telecom' },
        { img: energypower, name: 'Energy Power', route: '/Energy-monitoring-system' },
        { img: mining, name: 'Mining', route: '/Fuel-monitoring' },
        { img: health, name: 'Health', route: '/Health' },
        { img: indusauto, name: 'Industrial Automation', route: '/Airconditioner' },
        { img: aqua, name: 'Aqua Solutions', route: '/AQUA' },
        { img: water, name: 'Water Quality', route: '/Water-quality-management-solution' },
        { img: telematics, name: 'Telematics', route: '/Vehicle-Tracking-System' },
        { img: transport, name: 'Transport Industry', route: '/Vehicle-Tracking-System' },
        { img: foodChain, name: 'Food Chain Industry', route: '/Food-chain-industries' },
        { img: smartCities, name: 'Smart Cities', route: '/lora-based-water-meter' },
        { img: greenInfra, name: 'Green Infra Management', route: '/GIM' },
        { img: industry1, name: 'IoT', route: '/Battery-management' },
        { img: industry2, name: 'Consumer Electronics', route: '/Electronics' },
        { img: industry3, name: 'Core Strength', route: '/ComingSoon' },   
    ];

    const products = [
        { img: productImage1, name: 'LoRa Gateway', route: '/remote-gateways' },  
        { img: productImage2, name: 'Fuel and Fleet', route: '/Fuel-monitoring' },
        { img: productImage3, name: 'Remote Gateways', route: '/remote-gateways' },
        { img: productImage4, name: 'RFID Tag', route: '/rfid-tag' },
        { img: productImage5, name: 'RFID Reader', route: '/RFID-Reader' },
        { img: productImage6, name: 'Asset monitoring ', route: '/Asset-Monitoring-System' },
        { img: productImage7, name: 'Water Quality Monitor', route: '/Metro-Water-Quality' },
        { img: productImage8, name: ' Burgular Alarm System', route: '/Burgular-Alarm-System' },
        { img: productImage9, name: 'Truck Temperature Monitor', route: '/RF-Based-Temperature-Monitoring-For-Truck' },
        { img: productImage10, name: 'Cold Storage Monitor', route: '/Temperature-Monitoring-For-Cold-Storage' },
        { img: productImage11, name: 'Transport Tracker', route: '/Vehicle-Tracking-System' },
        { img: productImage12, name: 'Data Transfer Unit', route: '/Data-transfer-unit' },
        { img: productImage13, name: 'Remote Power Monitor', route: '/remote-gateways' },
    ];

    // Get window width to determine if mobile or desktop
    const { width } = useWindowSize();
    const isMobile = width <= 768;
    const imagesPerView = isMobile ? 3 : 5; // 5 images on desktop, 3 on mobile
    const slideWidth = isMobile ? 160 : 220; // 160px for mobile (150px + 10px margins), 220px for desktop (200px + 20px margins)

    // Calculate when the last image is visible for Industries
    const isLastIndustryImageVisible = currentSlide >= industries.length - imagesPerView;
    const handleNextIndustry = () => {
        if (!isLastIndustryImageVisible) {
            setCurrentSlide((prev) => prev + 1);
        }
    };
    const handlePrevIndustry = () => {
        if (currentSlide > 0) {
            setCurrentSlide((prev) => prev - 1);
        }
    };

    // Prevent event propagation to ensure Link works
    const handleLinkClick = (e) => {
        e.stopPropagation(); // Prevent carousel or parent events from interfering
    };

    return (
        <div className="home-container">
            <div className="video-section">
                <video autoPlay loop muted className="background-video">
                    <source src={backgroundVideo} type="video/mp4" />
                    Your browser does not support the video <tag className="z"></tag>
                </video>
                 <div className="video-overlay"></div>
   <div className="text-overlay">
    <div className="text-column">
        <div className="vision-text">
    <h2>VISION:</h2>
    <span>EMPOWERING A SMARTER, GREENER WORLD THROUGH CUTTING-EDGE AI-DRIVEN IOT, IT, AND ANALYTICS TO DELIVERS TRANSFORMATIVE INFRASTRUCTURE ACROSS INDUSTRIES, ENABLING SUSTAINABLE GROWTH, FUTURE-READY INNOVATION, AND TRUSTED PARTNERSHIPS THAT SHAPE TOMORROW.</span>
</div>
<div className="mission-text">
    <h2>MISSION:</h2>
    <span>TO BECOME A MARKET LEADER IN PROVIDING INNOVATIVE REAL-TIME IOT & IT BASED SOLUTIONS IN ENERGY, TELECOM, HEALTHCARE, AQUA, AUTOMOTIVE, SMART CITIES AND GREEN INFRA WITH MOTIVATED TEAM.</span>
</div>
       
    </div>
    <div className="text-column">
        <div className="values-text">
            <h2>Values:</h2>
            <span>WE LEAD WITH CONSULTATIVE INTEGRITY, EMBRACING RESPONSIBILITY AND ACCOUNTABILITY,<br></br> UPHOLDING UNCOMPROMISED QUALITY, AND WELCOMING CHANGE AS<br></br> A CATALYST FOR GROWTH.</span>
           
        </div>
        {/* <div className="strategy-text">
            <h2>Strategy:</h2>
            <span>LEVERAGING ACQUIRED KNOWLEDGE BASE, SKILL SET, EXPERIENCE WITH DOMAIN, SENSOR (RELEVANCE, ACCURACY, PRECISION) TECHNOLOGIES.</span>
        </div> */}
    </div>
</div>
            </div>

            <div className="about-vajra-section">
                <h2>VAJRA</h2>
                <p>Vajra-IoT offers high-performance GSM/GPRS, GPS, RF, Wi-Fi, Bluetooth, IoT, LoRa, RFID, Ethernet, and customized products based on state-of-the-art technology, meeting the toughest operating conditions and ensuring customer satisfaction.</p>
                <p>Vajra-IoT is committed to innovation and aggressively provides innovative and cost-effective solutions for wireless data transmission and efficient data handling to deliver customer-specific solutions for a wide variety of applications.</p>
                <p>
                    At Vajra, we are committed to revolutionizing IoT-based remote management solutions. 
                    With a focus on innovation and sustainability, we empower industries in energy, telecom, 
                    power, utility, aqua,Mining, Health, Industrial Automation, Transport Industry, food Chain industry, Smart cities, Green infra management, IoT, Consumer Electronics and Core strength to achieve smarter, more efficient operations.
                </p>
                <Link to="/Overview" className="learn-more-link">Learn More</Link>
            </div>

            <div className="core-strength">
                <h2>Core Strength</h2>
                <div className="strength-grid">
                    <div className="strength-item">
                        <img src={firmwareIcon} alt="Firmware Design" />
                        <h3>Firmware Design And Development</h3>
                        <p>Vajra specializes in designing robust and scalable firmware solutions tailored to your IoT needs, ensuring seamless integration and optimal performance.</p>
                        <Link to="/FirmwareDesignPage" className="learn-more-link">Learn More</Link>
                    </div>
                    <div className="strength-item">
                        <img src={hardwareIcon} alt="HardwareDesign" />
                        <h3>Hardware and PCB Design (D&D)</h3>
                        <p>Vajra excels in hardware and PCB design, ensuring high-quality, reliable, and cost-effective solutions for your IoT devices.</p>
                        <Link to="/HardwareDesign" className="learn-more-link">Learn More</Link>
                    </div>
                    <div className="strength-item">
              <video
                src={softwareVideo}
                alt="Software Application Services"
                className="feature-image"
                autoPlay
                loop
                muted
                playsInline
              />
              <h3 className="feature-title">Software Application Services</h3>
              <p className="feature-description">
                Vajra delivers cutting-edge software solutions, from cloud-based platforms to mobile applications, enabling smart and efficient remote management.
              </p>
              <Link to="/softwareDesign" className="learn-more-link">Learn More</Link>
            </div>
                    <div className="strength-item">
                        <img src={mechanicalIcon} alt="Mechanical Design" />
                        <h3>Mechanical Design</h3>
                        <p>Vajra’s mechanical design team creates durable and innovative enclosures and structures, ensuring your devices are both functional and aesthetically pleasing.</p>
                        <Link to="/MechDesign" className="learn-more-link">Learn More</Link>
                    </div>
                    <div className="strength-item">
                        <img src={testing} alt="Advanced Testing" />
                        <h3>Advanced Testing</h3>
                        <p>Vajra provides rigorous testing services to ensure your IoT solutions meet the highest standards of performance, reliability, and durability.</p>
                        <Link to="/Testing" className="learn-more-link">Learn More</Link>
                    </div>
                    <div className="strength-item">
                        <img src={production} alt="End to End Production" />
                        <h3>End to End Production</h3>
                        <p>Vajra manages the entire production process, from concept to completion, delivering fully integrated IoT solutions tailored to your specifications.</p>
                        <Link to="/EndtoEnd" className="learn-more-link">Learn More</Link>
                    </div>
                    <div className="strength-item">
                        <img src={pcb} alt="PCB Mounting and Assembly" />
                        <h3>PCB Mounting and Assembly</h3>
                        <p>Vajra offers precision PCB mounting and assembly services, ensuring high-quality, efficient, and reliable electronic components for your IoT devices.</p>
                        <Link to="/pcbmounting" className="learn-more-link">Learn More</Link>
                    </div>
                    <div className="strength-item">
                        <img src={mobileapp} alt="Mobile Application Android and iOS" />
                        <h3>Mobile Application Android and iOS</h3>
                        <p>Vajra develops intuitive and powerful mobile applications for Android and iOS, enhancing user experience and control over IoT systems.</p>
                        <Link to="/Mobile1" className="learn-more-link">Learn More</Link>
                    </div>
                    <div className="strength-item">
                        <img src={productEngIcon} alt="Product Engineering" />
                        <h3>Product Engineering</h3>
                        <p>Vajra’s product engineering services deliver end-to-end solutions, from concept to deployment, ensuring innovative and scalable IoT products.</p>
                        <Link to="/ProductEng" className="learn-more-link">Learn More</Link>
                    </div>
                    <div className="strength-item">
                        <img src={productSolutionIcon} alt="Product and Solution" />
                        <h3>Product and Solution</h3>
                        <p>Vajra provides comprehensive IoT solutions, integrating hardware, software, and services to address your unique business challenges.</p>
                        <Link to="/ProductandSol" className="learn-more-link">Learn More</Link>
                    </div>
                    <div className="strength-item">
                        <img src={manufacturingIcon} alt="Manufacturing" />
                        <h3>Manufacturing</h3>
                        <p>Vajra’s manufacturing expertise ensures high-quality production of IoT devices, optimized for efficiency, scalability, and reliability.</p>
                        <Link to="/Manu" className="learn-more-link">Learn More</Link>
                    </div>
                    <div className="strength-item">
                        <img src={techConsultingIcon} alt="Technology Consulting" />
                        <h3>Technology Consulting</h3>
                        <p>Vajra offers expert consulting to guide your IoT strategy, leveraging cutting-edge technologies to drive innovation and business success.</p>
                        <Link to="/Techconsulting" className="learn-more-link">Learn More</Link>
                    </div>
                </div>
            </div>

            <div className="experts-section">
                <h2>Experts in Industries</h2>
                <button
                    className={`nav-arrow left ${currentSlide === 0 ? 'disabled' : ''}`}
                    onClick={handlePrevIndustry}
                    disabled={currentSlide === 0}
                >
                    ←
                </button>
                <div className="carousel-wrapper">
                    <div className="strength-images-container">
                        <div className="strength-images" style={{ transform: `translateX(-${currentSlide * slideWidth}px)` }}>
                            {industries.map((industry, index) => (
                                <div className={`image-wrapper ${index === currentSlide ? 'leftmost' : ''}`} key={index}>
                                    <img src={industry.img} alt={industry.name} />
                                    <Link
                                        to={industry.route}
                                        className="image-name"
                                        onClick={handleLinkClick}
                                        aria-label={`Navigate to ${industry.name} solutions page`}
                                    >
                                        {industry.name}
                                    </Link>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
                <button
                    className={`nav-arrow right ${isLastIndustryImageVisible ? 'disabled' : ''}`}
                    onClick={handleNextIndustry}
                    disabled={isLastIndustryImageVisible}
                >
                    →
                </button>
            </div>

            <div className="products-section">
                <h2>Our Products</h2>
                <div className="products-carousel">
                    <div className="products-track">
                        {products.map((product, index) => (
                            <div className="image-wrapper" key={`product-${index}`}>
                                <img src={product.img} alt={product.name} className="product-logo" />
                                <Link
                                    to={product.route}
                                    className="image-name"
                                    onClick={handleLinkClick}
                                    aria-label={`Navigate to ${product.name} product page`}
                                >
                                    {product.name}
                                </Link>
                            </div>
                        ))}
                        {products.map((product, index) => (
                            <div className="image-wrapper" key={`product-dup-${index}`}>
                                <img src={product.img} alt={product.name} className="product-logo" />
                                <Link
                                    to={product.route}
                                    className="image-name"
                                    onClick={handleLinkClick}
                                    aria-label={`Navigate to ${product.name} product page`}
                                >
                                    {product.name}
                                </Link>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Home;    
 